import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@mui/material/styles'
import Typography from '@/v2/components/common/Typography'
import WarningIcon from '@mui/icons-material/WarningAmberRounded'
import { usePatientContext } from '@/v2/contexts/PatientContext'

const WarningBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.red.medicalAlert};
  color: ${({ theme }) => theme.background.default};
  border-left: 4px solid ${({ theme }) => theme.red.main};
`

const OverduePaymentWarning = () => {
  const theme = useTheme()
  const { patient } = usePatientContext()

  if (!patient?.hasOverdueInvoice) return null

  return (
    <WarningBox theme={theme.palette}>
      <WarningIcon sx={{ fontSize: '18px', flexShrink: 0 }} />
      <Typography fontSize="13px">
        This patient has an overdue invoice or a declined payment (from
        automatic charge) that requires attention.
      </Typography>
    </WarningBox>
  )
}

export default OverduePaymentWarning
